import apiClient from './apiClient';

const API_URL = '/tramites/reajuste';

// Listar / filtrar trámites de Reajuste
export const getTramitesReajuste = async (idCliente = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite (incluye checklist y sentencias)
export const getTramiteReajusteById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear un nuevo trámite de Reajuste
export const crearTramiteReajuste = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite de Reajuste:', error.response?.data || error.message);
        throw error;
    }
};

// Preview en vivo del checklist de documentación, condicionado por tipoReajuste
export const getChecklistFormularios = async (tipoReajuste = 'OTRO') => {
    const params = { tipoReajuste };
    const response = await apiClient.get(`${API_URL}/formularios`, { params });
    return response.data;
};

// Editar datos del trámite (no el cliente)
export const actualizarTramiteReajuste = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable con firma)
export const actualizarComentariosReajuste = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

// Editar solo el cálculo (diferencias/retroactivo con y sin IPC), independiente de "Datos del Beneficio"
export const actualizarCalculoReajuste = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}/calculo`, dto);
    return response.data;
};

// Fecha de llamado al cliente (aviso previo al turno ANSES, antes del reclamo administrativo)
export const actualizarFechaLlamadoReajuste = async (id, fechaLlamado) => {
    const response = await apiClient.patch(`${API_URL}/${id}/llamado`, { fechaLlamado });
    return response.data;
};

// Panel de Ejecución / Cobro: retroactivo adelantado/pendiente/pagado y su fecha. Se edita libre
// (no de una sola vez): mientras se espera que ANSES resuelva el expediente "150" puede reajustar
// el haber o pagar un adelanto varias veces.
export const actualizarCobroReajuste = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}/cobro`, dto);
    return response.data;
};

// Avanzar de estado: cada transición manda su propio mini-formulario (destino + dato del hito)
export const avanzarEstadoReajuste = async (id, dto) => {
    const response = await apiClient.patch(`${API_URL}/${id}/estado`, dto);
    return response.data;
};

// Actualizar un ítem del checklist (marcar presentado / adjuntar archivo)
export const actualizarChecklistItem = async (idItem, { presentado, idArchivo }) => {
    const response = await apiClient.patch(`${API_URL}/formularios/${idItem}`, { presentado, idArchivo });
    return response.data;
};

// Sentencia: una fila por instancia (PRIMERA_INSTANCIA / CAMARA)
export const getSentenciasReajuste = async (idTramite) => {
    const response = await apiClient.get(`${API_URL}/${idTramite}/sentencias`);
    return response.data;
};

export const guardarSentenciaReajuste = async (idTramite, tipoInstancia, dto) => {
    const response = await apiClient.put(`${API_URL}/${idTramite}/sentencias/${tipoInstancia}`, dto);
    return response.data;
};

const reajusteService = {
    getTramitesReajuste,
    getTramiteReajusteById,
    crearTramiteReajuste,
    getChecklistFormularios,
    actualizarChecklistItem,
    actualizarTramiteReajuste,
    actualizarComentariosReajuste,
    actualizarCalculoReajuste,
    actualizarFechaLlamadoReajuste,
    actualizarCobroReajuste,
    avanzarEstadoReajuste,
    getSentenciasReajuste,
    guardarSentenciaReajuste,
};

export default reajusteService;
